/**
 * Holds a minutes field to whole steps - `minute-step="5"` allows 10, 15, 20 but not 17. A number
 * input's own `step` only hints: the browser still accepts any number typed into it. This makes an
 * off-step value invalid (ngModel error `minuteStep`, so the form will not submit it), and rounds it to
 * the nearest step when the field is left, within any `min`/`max` set on the input.
 */
app.directive("minuteStep", function () {
	return {
		restrict: "A",
		require: "ngModel",
		link: function (scope, element, attrs, ngModel) {
			const step = function () {
				return Number(attrs.minuteStep) || 5;
			};

			ngModel.$validators.minuteStep = function (value) {
				if (value === null || value === undefined || value === "") {
					return true; // "required" says whether it may be empty
				}
				return Number(value) % step() === 0;
			};

			element.on("blur", function () {
				const value = Number(ngModel.$viewValue);
				if (ngModel.$viewValue === "" || ngModel.$viewValue === null || isNaN(value) || value % step() === 0) {
					return;
				}
				let rounded = Math.round(value / step()) * step();
				if (attrs.min !== undefined && rounded < Number(attrs.min)) {
					rounded = Math.ceil(Number(attrs.min) / step()) * step();
				}
				if (attrs.max !== undefined && rounded > Number(attrs.max)) {
					rounded = Math.floor(Number(attrs.max) / step()) * step();
				}
				scope.$evalAsync(function () {
					ngModel.$setViewValue(rounded);
					ngModel.$render();
				});
			});
		},
	};
});
